import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container sub_page _activity" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ActivityList = _resolveComponent("ActivityList")!
  const _component_EventList = _resolveComponent("EventList")!
  const _component_SuggestList = _resolveComponent("SuggestList")!
  const _component_ActionList = _resolveComponent("ActionList")!
  const _component_ActionState = _resolveComponent("ActionState")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"deco_wrap\"><i class=\"deco_01\"><img src=\"img/activity_left.png\"></i><i class=\"deco_02 _small blink4\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_03 _small blink_zoom1\"><img src=\"img/b_icon_02.png\"></i><i class=\"deco_04 _xxsmall blink_zoom4\"><img src=\"img/b_icon_05.png\"></i><i class=\"deco_05 none_768 spin2 _medium\"><img src=\"img/b_icon_03.png\"></i><i class=\"deco_06 none_768 spin_blink3 _small\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_07 none_768 blink_zoom4 _small\"><img src=\"img/b_icon_02.png\"></i><i class=\"deco_character\"><img src=\"img/activity_icon.png\"></i></div><div class=\"banner_wrap wrap_1120\"><h2>시민참여 활동</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab(1))),
              class: _normalizeClass([$setup.state.tab === 1 ? 'active' : ''])
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "반성매매 시민활동", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab(2))),
              class: _normalizeClass([$setup.state.tab === 2 ? 'active' : ''])
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "캠페인·이벤트", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab(3))),
              class: _normalizeClass([$setup.state.tab === 3 ? 'active' : ''])
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "참여하고 싶은 반성매매 활동 제안", -1)
            ]))], 2),
            ($setup.user.isLogin())
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {
                            $setup.changeTab(4);
                            $setup.state.stateIdx = 0;
                        }),
                  class: _normalizeClass([[$setup.state.tab === 4 ? 'active' : ''], "w_1024_custom_width"])
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("a", { href: "javascript:void(0)" }, "액션 시민 활동", -1)
                ]))], 2))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      ($setup.state.tab === 1)
        ? (_openBlock(), _createBlock(_component_ActivityList, { key: 0 }))
        : ($setup.state.tab === 2)
          ? (_openBlock(), _createBlock(_component_EventList, { key: 1 }))
          : ($setup.state.tab === 3)
            ? (_openBlock(), _createBlock(_component_SuggestList, { key: 2 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                ($setup.state.tab === 4 && $setup.state.stateIdx && $setup.user.isLogin())
                  ? (_openBlock(), _createBlock(_component_ActionList, {
                      key: 0,
                      stateIdx: $setup.state.stateIdx
                    }, null, 8, ["stateIdx"]))
                  : _createCommentVNode("", true),
                ($setup.state.tab === 4 && !$setup.state.stateIdx && $setup.user.isLogin())
                  ? (_openBlock(), _createBlock(_component_ActionState, {
                      key: 1,
                      onSelectState: $setup.selectState
                    }, null, 8, ["onSelectState"]))
                  : _createCommentVNode("", true)
              ], 64))
    ]),
    _createVNode(_component_Footer)
  ], 64))
}